import { jsx as a } from "react/jsx-runtime";
import { q as c, P as n } from "../index-DiWzAyMV.js";
import { c as i } from "../index-BNmRGtA6.js";
import { c as m } from "../clsx-OuTLNxxd.js";
import { B as u } from "../Badge-2G452vY2.js";
import '../Status.css';const l = "_status_m614s_1", O = "_success_m614s_5", r = {
  status: l,
  success: O
}, d = i(r.status, {
  variants: {
    status: {
      WON: r.success,
      LOST: r.error
    }
  },
  defaultVariants: {
    status: "WON"
  }
}), x = ({
  className: t,
  status: s,
  ...e
}) => {
  if (s !== "WON" && s !== "LOST") return null;
  const o = {
    WON: "primary",
    LOST: "error"
  };
  return /* @__PURE__ */ a(
    u,
    {
      "aria-label": `${s.toLowerCase()}-badge`,
      className: m(d({ status: s }), t),
      "data-cxy-name": "status",
      isRound: !0,
      size: "l",
      variant: o[s],
      ...e,
      children: s === "WON" ? /* @__PURE__ */ a(c, {}) : /* @__PURE__ */ a(n, {})
    }
  );
};
export {
  x as Status
};
